export class WebMails {
    AutoID: number = 0;
    IdDossier: number;
    ItemId: string;
    DeNom: string;
    DeEmail: string;
    DateHeure: string;
    Sujet: string;
    Body: string;
    PJ: number;
    IsMsg: boolean;
    ANom: string;
    AEmail: string;
    IdTheme: number = 0;
    idCollaborateur: number;
    WebMailPiecesJointes: WebMailPiecesJointes[] = [];

    constructor() {
        this.WebMailPiecesJointes = [];
    }
}

export class WebMailPiecesJointes {
    AutoID?: number = 0;
    WebMailsID?: number = 0;
    Nom: string;
    TypePieceJointe: string;
    TypeContenu: string;
    ContenuBase64: string;
    Taille: number;
}
